import { configApiBackend } from '@gleerups/api-fetch';

const apiBackend = configApiBackend({
  redirectOnUnauthorized: false,
});

export default apiBackend;
